import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import merge from 'lodash-es/merge';
import {AlertComponent} from "../../../views/modal/alert.component";
import {HelperService} from "../../../lib/helper.service";
import {ModalService} from "../../../views/modal/base_modal.component";
import {TranslateService} from "../../../translate";
import { SitesService } from "../../../sites/sites.service";

@Component({
	templateUrl: './site_category_details.component.html'
})
export class SiteCategoryDetailsComponent extends InfoModalComponent {
	detailLoader: boolean = false;
	details;
	
	totalCount: number;
	currentPage: number = 1;
	categoryId: string;
	subjectId: string;
	params: any = {};

	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public modalService: ModalService,
		public translate: TranslateService,
		public siteService: SitesService,
	) {
		super(activeModal);
	}

	ok() {
		this.close();
	}
	
	async onPageChange() {
		this.detailLoader = true;
		
		const { stats } = await this.siteService.siteCategories.detail(
			merge({}, { categoryId: this.categoryId, subjectId: this.subjectId, page: this.currentPage })
		).toPromise();
		
		this.details = stats;
		
		this.detailLoader = false;
	}
	
	async downloadButton() {
		window.location.href = this.siteService.siteCategories.downloadFileRoute(
			merge({}, this.params, { categoryId: this.categoryId, subjectId: this.subjectId, page: this.currentPage }),
			'download'
		);

		this.modalService.open(AlertComponent, {
			title: 'INFO',
			message: this.translate.__A('common.download file')
		});
	}
}
